document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.mw-header');
  const syncHeaderState = () => header && header.classList.toggle('is-scrolled', window.scrollY > 12);
  syncHeaderState();
  window.addEventListener('scroll', syncHeaderState, { passive: true });

  document.querySelectorAll('[data-mw-menu-toggle]').forEach((btn) => {
    const menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;

    const closeMenu = () => {
      btn.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
    };

    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });

    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  });

  document.querySelectorAll('[data-mw-product-form]').forEach((form) => {
    const idInput = form.querySelector('input[name="id"]');
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const section = form.closest('.mw-section, .mw-product-main') || document;

    form.querySelectorAll('[data-mw-variant]').forEach((input) => {
      input.addEventListener('change', () => {
        if (idInput) idInput.value = input.value;

        if (input.dataset.price) {
          section.querySelectorAll('[data-mw-price]').forEach((price) => {
            price.textContent = input.dataset.price;
          });
          document.querySelectorAll('[data-mw-sticky-price]').forEach((price) => {
            price.textContent = input.dataset.price.replace(/\s+[A-Z]{3}$/i, '');
          });
        }

        if (input.dataset.serveCost) {
          section.querySelectorAll('[data-mw-serve-cost]').forEach((serveCost) => {
            serveCost.textContent = input.dataset.serveCost;
          });
        }

        if (input.dataset.image) {
          const productMainImage = section.querySelector('[id^="mw-main-product-image-"]');
          const featuredImage = section.querySelector('.mw-buy__gallery img');
          const image = productMainImage || featuredImage;
          if (image) {
            image.src = input.dataset.image;
            image.srcset = '';
          }
        }
      });
    });

    form.querySelectorAll('[data-mw-selling-plan]').forEach((input) => {
      input.addEventListener('change', () => {
        if (sellingPlanInput) sellingPlanInput.value = input.value;
      });
    });
  });

  document.querySelectorAll('[data-mw-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const target = document.getElementById(thumb.dataset.target);
      const img = thumb.querySelector('img');
      if (target && img) {
        target.src = img.dataset.full || img.src;
        target.srcset = '';
        target.alt = img.alt || '';
      }
    });
  });

  document.querySelectorAll('[data-mw-sticky-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const form = document.querySelector('[data-mw-primary-product-form]');
      if (form) form.requestSubmit();
    });
  });

  const primaryForm = document.querySelector('[data-mw-primary-product-form]');
  const stickyBar = document.querySelector('.mw-sticky-atc');
  if (primaryForm && stickyBar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });
    observer.observe(primaryForm);
  } else if (stickyBar) {
    stickyBar.classList.add('is-visible');
  }
});
